import React, { useEffect } from "react";

const ContactUs: React.FC = () => {
  useEffect(() => {
    // Load the Calendly widget script
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = {
      name: (form.elements.namedItem("name") as HTMLInputElement).value,
      email: (form.elements.namedItem("email") as HTMLInputElement).value,
      phone: (form.elements.namedItem("phone") as HTMLInputElement).value,
      message: (form.elements.namedItem("message") as HTMLTextAreaElement)
        .value,
    };

    try {
      const response = await fetch("/.netlify/functions/proxy", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      if (result.success) {
        alert("Your message has been sent!");
        form.reset(); // Reset the form after successful submission
      } else {
        alert("Failed to send your message: " + result.message);
      }
    } catch (error) {
      if (error instanceof Error) {
        alert("An error occurred: " + error.message);
      } else {
        alert("An unknown error occurred.");
      }
    }
  };

  return (
    <section id="contact-us" className="py-20 px-6">
      <div className="container mx-auto">
        <h2 className="text-4xl md:text-5xl text-center font-bold mb-4 text-[#1E3A8A]">
          Contact Us
        </h2>
        <p className="text-center text-lg mb-6">
          Contact us by completing the form below, or set up a quick call with
          one of our team members to discuss your project.
        </p>
        <div className="flex justify-center">
          <div className="grid grid-cols-1 md:grid-cols-1 gap-8 w-full max-w-5xl">
            {/* Contact Form */}
            <div className="flex justify-center">
              <form
                id="contactForm"
                onSubmit={handleSubmit}
                className="w-full mx-auto max-w-lg space-y-4 py-10 bg-white p-6 rounded-lg shadow-lg"
              >
                <div>
                  <label htmlFor="name" className="block font-medium">
                    Name:
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full border rounded px-3 py-2 focus:outline-none"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block font-medium">
                    Email:
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full border rounded px-3 py-2 focus:outline-none"
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block font-medium">
                    Phone:
                  </label>
                  <input
                    type="text"
                    id="phone"
                    name="phone"
                    className="w-full border rounded px-3 py-2 focus:outline-none"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block font-medium">
                    Message:
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    className="w-full border rounded px-3 py-2 focus:outline-none"
                  ></textarea>
                </div>
                <div className="flex justify-center">
                  <button
                    type="submit"
                    className="bg-[#1E3A8A] text-white px-4 py-2 rounded focus:outline-none"
                  >
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
